import * as Yup from "yup";

const questionSchema = Yup.object().shape({
  answer: Yup.string()
    .oneOf(["yes", "no", "n/a"], "Answer must be one of: yes, no, or n/a")
    .required("Response Value is Required"),
  comment: Yup.string(),
});

export const patientCareValidationSchema = Yup.object().shape({
  residentName: Yup.string().required("Resident name is required"),
  facility: Yup.string().required("Facility name is required"),
  unit: Yup.string().required("Unit name is required"),
  personalCareAudit: Yup.object().shape({
    hair: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
    }),
    face: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
    }),
    fingerNails: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
    }),
    clothing: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
    }),
    oralCare: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
    }),
    continenceCare: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
    }),
    personalItems: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
    }),
    overallAppearance: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
    }),
    compliance: Yup.object().shape({
      percentage: Yup.number()
        .max(1, "Can't be higher than 1")
        .min(0, "Can't be lower than 0")
        .required("Compliance percentage is required"),
    }),
  }),
  residentEnvironment: Yup.object().shape({
    bedding: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
    }),
    towels: Yup.object().shape({
      q1: questionSchema,
    }),
    compliance: Yup.object().shape({
      percentage: Yup.number()
        .max(1, "Can't be higher than 1")
        .min(0, "Can't be lower than 0")
        .required("Compliance percentage is required"),
    }),
  }),
  mobilityAids: Yup.object().shape({
    mobilityAids: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
      q4: questionSchema,
    }),
    compliance: Yup.object().shape({
      percentage: Yup.number()
        .max(1, "Can't be higher than 1")
        .min(0, "Can't be lower than 0")
        .required("Compliance percentage is required"),
    }),
  }),
  pcc: Yup.object().shape({
    pcc: Yup.object().shape({
      q1: questionSchema,
    }),
    compliance: Yup.object().shape({
      percentage: Yup.number()
        .max(1, "Can't be higher than 1")
        .min(0, "Can't be lower than 0")
        .required("Compliance percentage is required"),
    }),
  }),
  additionalComments: Yup.string(),
});
